import { combineReducers } from 'redux';

const masterInitialState = {
  code: '',
  list: null,
  loadStatus: 0,
};

const cartInitialState = {
  list: [],
  price: 0,
  cartNum: 0,
};

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_HAPPYGO_PRODUCT_MASTER': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_HAPPYGO_PRODUCT_MASTER_COMPLETION': {
      const { error } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
          code: error.code,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: action.list.map(product => product.productCode),
      };
    }

    default:
      return state;
  }
}

function productsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_HAPPYGO_PRODUCT_MASTER_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return list.reduce(
        (obj, product) => {
          obj[product.productCode] = product;
          return obj;
        },
        { ...state }
      );
    }

    default:
      return state;
  }
}

function cartReducer(state = cartInitialState, action) {
  switch (action.type) {
    case 'ADD_HAPPYGO_PRODUCT': {
      const { code } = action;

      let cartList = state.list.slice();
      let isExist = false;
      cartList.map(item => {
        if (item.code === code) {
          item['num'] = item.num + 1;
          isExist = true;
        }
        return null;
      });

      if (!isExist) {
        cartList.push({ code, num: 1 });
      }

      let sum = 0;
      cartList.map(item => (sum += item.num));
      return {
        ...state,
        list: cartList,
        price: state.price + action.price,
        cartNum: sum,
      };
    }

    case 'DELETE_ALL_HAPPYGO_PRODUCT': {
      return cartInitialState;
    }

    case 'DELETE_HAPPYGO_PRODUCT': {
      let price = state.price;
      let cartNum = state.cartNum;
      state.list.map(item => {
        if (item.code === action.code) {
          price = price - item.num * action.price;
          cartNum = cartNum - item.num;
        }
        return null;
      });
      return {
        ...state,
        price,
        cartNum,
        list: state.list.filter(item => {
          return item.code !== action.code;
        }),
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: masterReducer,
  products: productsReducer,
  cart: cartReducer,
});
